import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import css from './IconDuplicatePlus.module.css';

const IconDuplicatePlus = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 16C15.2833 16 15.521 15.904 15.713 15.712C15.9043 15.5207 16 15.2833 16 15V13H18C18.2833 13 18.5207 12.904 18.712 12.712C18.904 12.5207 19 12.2833 19 12C19 11.7167 18.904 11.479 18.712 11.287C18.5207 11.0957 18.2833 11 18 11H16V9C16 8.71667 15.9043 8.479 15.713 8.287C15.521 8.09567 15.2833 8 15 8C14.7167 8 14.4793 8.09567 14.288 8.287C14.096 8.479 14 8.71667 14 9V11H12C11.7167 11 11.4793 11.0957 11.288 11.287C11.096 11.479 11 11.7167 11 12C11 12.2833 11.096 12.5207 11.288 12.712C11.4793 12.904 11.7167 13 12 13H14V15C14 15.2833 14.096 15.5207 14.288 15.712C14.4793 15.904 14.7167 16 15 16ZM4.425 19.775C3.09167 19.025 2.021 17.9583 1.213 16.575C0.404333 15.1917 0 13.6667 0 12C0 10.3333 0.412667 8.804 1.238 7.412C2.06267 6.02067 3.18333 4.925 4.6 4.125C4.93333 3.94167 5.25 3.95833 5.55 4.175C5.85 4.39167 6 4.69167 6 5.075C6 5.24167 5.95 5.41667 5.85 5.6C5.75 5.78333 5.61667 5.91667 5.45 6C4.38333 6.63333 3.54167 7.479 2.925 8.537C2.30833 9.59567 2 10.75 2 12C2 13.25 2.30833 14.4043 2.925 15.463C3.54167 16.521 4.38333 17.3667 5.45 18C5.61667 18.0833 5.75 18.2167 5.85 18.4C5.95 18.5833 6 18.7667 6 18.95C6 19.3333 5.84167 19.625 5.525 19.825C5.20833 20.025 4.84167 20.0083 4.425 19.775ZM15 21C13.75 21 12.5793 20.7627 11.488 20.288C10.396 19.8127 9.446 19.1707 8.638 18.362C7.82933 17.554 7.18767 16.604 6.713 15.512C6.23767 14.4207 6 13.25 6 12C6 10.75 6.23767 9.579 6.713 8.487C7.18767 7.39567 7.82933 6.44567 8.638 5.637C9.446 4.829 10.396 4.18733 11.488 3.712C12.5793 3.23733 13.75 3 15 3C16.25 3 17.421 3.23733 18.513 3.712C19.6043 4.18733 20.5543 4.829 21.363 5.637C22.171 6.44567 22.8127 7.39567 23.288 8.487C23.7627 9.579 24 10.75 24 12C24 13.25 23.7627 14.4207 23.288 15.512C22.8127 16.604 22.171 17.554 21.363 18.362C20.5543 19.1707 19.6043 19.8127 18.513 20.288C17.421 20.7627 16.25 21 15 21ZM15 19C16.95 19 18.604 18.3207 19.962 16.962C21.3207 15.604 22 13.95 22 12C22 10.05 21.3207 8.39567 19.962 7.037C18.604 5.679 16.95 5 15 5C13.05 5 11.396 5.679 10.038 7.037C8.67933 8.39567 8 10.05 8 12C8 13.95 8.67933 15.604 10.038 16.962C11.396 18.3207 13.05 19 15 19Z"
        fill="white"
      />
    </svg>
  );
};

IconDuplicatePlus.defaultProps = { className: null };

IconDuplicatePlus.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconDuplicatePlus;
